import { atom } from 'jotai';
import type { Theme } from '../colors/color-palette';
export const currentThemeAtom = atom<Theme>('Light');